import { useEffect, useState } from "react";
import * as logger from "loglevel";
import * as prefix from "loglevel-plugin-prefix";
import { sender, setLogInstance } from "./log-remote";
import { useSelector } from "react-redux";
import {
  selectSessionToken,
  selectUserId,
} from "@features/session/sessionSlice";
import { selectRoles } from "@features/user/userSlice";

var log = null;

const useLog = (prop) => {
  // debug display level
  const logLevelStorage = process.env.REACT_APP_LOG_LEVEL || "TRACE";
  const sendRemote =
    (process.env.REACT_APP_LOG_REMOTE === "TRUE" ? true : false) || false;
  const displayLogLevel = logLevelStorage.toUpperCase(); //["INFO", "WARN", "ERROR", "DEBUG"]
  const application = "portal"; // application name to use for logging

  // user session logging
  const userIdSelector = useSelector(selectUserId);
  const sessionToken = useSelector(selectSessionToken);
  const roles = useSelector(selectRoles);

  // server log route
  const senderInterval = 10000; // milliseconds

  const [remoteConfig, setRemoteConfig] = useState({
    senderInterval,
    user_id: null,
    token: null,
    scopes: null,
    application,
    level: logLevelStorage,
  });
  
  useEffect(() => {
    if (userIdSelector && sessionToken && sendRemote) {
      setRemoteConfig((prev) => ({
        ...prev,
        ...{
          user_id: userIdSelector,
          token: sessionToken,
          scopes: roles,
        },
      }));
    }
  }, [userIdSelector, sessionToken, sendRemote, roles]);

  useEffect(() => {
    if (sendRemote && remoteConfig.user_id && remoteConfig.scopes && remoteConfig.token) {
      sender(remoteConfig);
    }
  }, [remoteConfig, sendRemote]);

  // Create a new instance of the logger
  const initLog = () => {
    prefix.reg(logger);
    prefix.apply(logger, {
      template: "[%t] %l:",
      levelFormatter(level) {
        return level.toUpperCase();
      },
      timestampFormatter(date) {
        return date.toISOString();
      },
    });
    logger.setLevel(displayLogLevel);

    // Send if flag is set to true
    if (sendRemote) {
      setLogInstance(logger);
      sender(remoteConfig);
    }

    return logger;
  };

  // Returns the  current instance of the logger
  const singleton = () => {
    if (!log) {
      log = initLog();
    }
    return log;
  };

  return {
    singleton,
  };
};

var getStackTrace = function () {
  var obj = {};
  Error.captureStackTrace(obj, getStackTrace);
  return obj.stack;
};

export { useLog, log, getStackTrace };
